import { AppUser } from "../models/user";

// A "shop user" is an authenticated store user without any of the management
// roles (Admin / HQteam / Picker). Mirrors the `isShop` derivation used in the
// tables, but as a plain predicate so it can run outside React (e.g. thunks).
const MANAGEMENT_ROLES = ["Admin", "HQteam", "Picker"];

export default function isShopUser(user: AppUser | null | undefined): boolean {
  if (!user) return false;
  return !user.roles.some((role) => MANAGEMENT_ROLES.includes(role));
}
